import { HireBikeCompanies } from '@bikes/constants/hireCompanies';
import { useBikesStore } from '@bikes/store/store';

type PayloadType = {
  ReportObject: {
    provider?: HireBikeCompanies | null | undefined;
    ownership_type: string;
    obstruction_type: string;
    vehicle_type: string;
    more_details: string;
  };
  ServiceLocationObject: {
    address_line_1: string;
    address_line_2: string;
    town_city: string;
    county: string;
    postcode: string;
    country: string;
    UPRN: string;
    USRN: string;
    easting: string | null;
    northing: string | null;
    latitude: number | null;
    longitude: number | null;
    additional_details: string;
  };
  ChannelObject: {
    channel: string;
    platform: string;
    session_id: string;
  };
  ReporterObject: {
    can_be_contacted: boolean;
    contact_id: string;
    name: {
      first_name: string;
      middle_name: string;
      last_name: string;
    };
    contact_details: {
      email_address: string;
      phone_number: null;
    } | null;
  };
  FileCollectionObject:
    | {
        external: boolean;
        files: {
          name: string;
          path: string;
        }[];
      }
    | null
    | undefined;
};

export const BikesPayload = (): PayloadType => {
  const {
    firstName,
    lastName,
    email,
    serviceLocationDetails,
    tellUsMoreText,
    bikesTypeLabel,
    hireCompany,
    uploadedImagesBlob,
    obstructionType,
    receiveConfirmationEmail,
    sessionId,
  } = useBikesStore();

  const {
    address_line_1,
    address_line_2,
    town_city,
    county,
    postcode,
    country,
    UPRN,
    USRN,
    latitude,
    longitude,
    easting,
    northing,
  } = serviceLocationDetails;

  let uploadedFiles: { name: string; path: string }[] = [];
  uploadedImagesBlob?.forEach((file) => {
    uploadedFiles.push({
      name: file.filename,
      path: file.blob_uri,
    });
  });

  const payload = {
    ReportObject: {
      ownership_type: bikesTypeLabel?.includes('hire') ? 'Hire' : 'Personal',
      obstruction_type: obstructionType,
      vehicle_type: bikesTypeLabel?.includes('scooter') ? 'Scooter' : 'Bike',
      more_details: tellUsMoreText,
      ...(bikesTypeLabel?.includes('hire') && { provider: hireCompany }),
    },
    ServiceLocationObject: {
      address_line_1,
      address_line_2,
      town_city,
      county,
      postcode,
      country,
      UPRN,
      USRN,
      easting,
      northing,
      latitude,
      longitude,
      additional_details: '',
    },
    ChannelObject: {
      channel: 'Online',
      platform: 'React',
      session_id: sessionId,
    },
    ReporterObject: {
      can_be_contacted: receiveConfirmationEmail === 'Yes',
      contact_id: '',
      name: {
        first_name: firstName,
        middle_name: '',
        last_name: lastName,
      },
      contact_details: {
        email_address: email,
        phone_number: null,
      },
    },
    ...(uploadedFiles?.length > 0 && {
      FileCollectionObject: {
        external: false,
        files: uploadedFiles,
      },
    }),
  };

  return payload as PayloadType;
};
